/**
 * This is where we dispatch store actions before the store is used
 * in any component. For example, we initialise the store itself by
 * pre-loading some data.
 */
import { toast } from './toaster.client.js';
import { errorFromResponse } from '../src/common/general-utils.js';
import { axios } from './axios.client.js';

export default defineNuxtPlugin({
  async setup() {
    const route = useRoute();
    const nuxtApp = useNuxtApp();
    const { store: $store } = await import('../store/index.js');
    nuxtApp.vueApp.use($store);

    window.store = $store; // for debugging only
    $store.$toast = toast;
    $store.$axios = axios;
    $store.vueApp = nuxtApp.vueApp;

    $store.$errorFromResponse = errorFromResponse(nuxtApp.$i18n.global.t.bind(nuxtApp.$i18n.global.t));
    const isExternalFormRoute = route.path.startsWith('/form');
    if (!route.path.startsWith('/verify-otp')) {
      await $store.dispatch('forceLogoutCheck');
      if ($store.state.forceLogout === 'Authorized' && !isExternalFormRoute) {
        await $store.dispatch('preload/preloadData');
      }
    }

    return {
      provide: {
        enforce: 'pre', // or 'post'
        store: $store,
        errorFromResponse: $store.$errorFromResponse
      }
    };
  }
});
